import HomeLayout from '../../components/home/HomeLayout'
//import './HomePage.css'

const HomePage = () => {
  return (
    <div className="">
      <HomeLayout/>
    </div>
  )
}

export default HomePage;
